import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  if (config.headers) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (erro) => {
    const { response } = erro;
    if (response?.status === 401) {
      toast.error("Sem autorização!");
      window.location.replace("/");
    } else if (response?.status === 409) {
      toast.error(response?.data?.message || "Esse item já está cadastrado.");
    }
    return Promise.reject(erro);
  }
);
export default api;
